import { AddCommentIcon, EditCommentIcon, Link, useInteractiveTableContext } from '@dreryk/react-components';

import { DiagnosisTableBean } from '../../DiagnosesFormTab.types';
import { OnDiagnosisAdditionalInformationChanged } from '../diagnosisAdditionalInformation/DiagnosisAdditionalInformationModal.types';
import { DiagnosisAdditionalInformationModalOpener } from '../diagnosisAdditionalInformation/DiagnosisAdditionalInformationModalOpener';

type DiagnosisAdditionalInformationCellProps = {
   readonly code: string;
   readonly name: string;
   readonly visitId: number;
   readonly index: number;
};

export const DiagnosisAdditionalInformationCell = (props: DiagnosisAdditionalInformationCellProps): JSX.Element => {
   const { setCellValue, getCellValue } = useInteractiveTableContext<DiagnosisTableBean>();

   const handleSuccess: OnDiagnosisAdditionalInformationChanged = (additionalInformation) => {
      setCellValue('additionalInformation', props.index, additionalInformation ?? null);
   };

   const additionalInformation = getCellValue('additionalInformation', props.index);

   return (
      <DiagnosisAdditionalInformationModalOpener
         code={props.code}
         name={props.name}
         additionalInformation={additionalInformation}
         visitId={props.visitId}
         onSuccess={handleSuccess}
      >
         {({ openModal }) => (
            <Link
               testId={`${additionalInformation ? 'edit' : 'add'}DiagnosisAdditionalInformation`}
               icon={additionalInformation ? <EditCommentIcon /> : <AddCommentIcon />}
               onClick={openModal}
            />
         )}
      </DiagnosisAdditionalInformationModalOpener>
   );
};
